import { Button } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ProcessButton = (props) => {
  const { t } = useTranslation();
  const {
    loading = false, text = t('globals.continue'), size = 500, ...rest
  } = props;

  return (
    <Button
      w={size}
      loading={loading}
      rightSection={<IconArrowLeft size={24} />}
      {...rest}
    >
      {text}
    </Button>
  );
};

export default ProcessButton;

ProcessButton.propTypes = {
  loading: PropTypes.bool,
  text: PropTypes.string,
  size: PropTypes.number,
};
